import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Receipts() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Receipts
			</Text>
			<Text variant='caption' gutterBottom>
				- Summary of donors Receipts<br/>
				- Breakdown of payment methods
			</Text>
		</Paper>
	)
}
export default Receipts
